/**
 * Feature Service
 * AIDLC Administrative Frontend
 *
 * API calls for feature CRUD operations.
 */

import apiClient from './api';
import type { Feature, FeatureWithProgress, FeatureSummary } from '../types/feature';

const FEATURES_PATH = '/features';

export async function getFeatures(params?: Record<string, string>): Promise<Feature[]> {
  const query = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([k, v]) => { if (v) query.set(k, v); });
  }
  const qs = query.toString();
  const response = await apiClient.get<Feature[]>(`${FEATURES_PATH}${qs ? `?${qs}` : ''}`);
  return response.data;
}

export async function getFeatureSummary(): Promise<FeatureSummary> {
  const response = await apiClient.get<FeatureSummary>(`${FEATURES_PATH}/summary`);
  return response.data;
}

export async function getFeature(id: string): Promise<FeatureWithProgress> {
  const response = await apiClient.get<FeatureWithProgress>(`${FEATURES_PATH}/${id}`);
  return response.data;
}

export async function createFeature(data: {
  title: string;
  description?: string;
  project: string;
  status?: string;
  priority?: string;
  owner?: string | null;
  labels?: string[];
  targetDate?: string | null;
}): Promise<Feature> {
  const response = await apiClient.post<Feature>(FEATURES_PATH, data);
  return response.data;
}

export async function updateFeature(id: string, updates: Partial<Feature>): Promise<Feature> {
  const response = await apiClient.put<Feature>(`${FEATURES_PATH}/${id}`, updates);
  return response.data;
}

export async function deleteFeature(id: string): Promise<void> {
  await apiClient.delete(`${FEATURES_PATH}/${id}`);
}

export async function addItemsToFeature(featureId: string, itemIds: string[]): Promise<FeatureWithProgress> {
  const response = await apiClient.post<FeatureWithProgress>(`${FEATURES_PATH}/${featureId}/items`, { itemIds });
  return response.data;
}

export async function removeItemsFromFeature(featureId: string, itemIds: string[]): Promise<FeatureWithProgress> {
  const response = await apiClient.delete<FeatureWithProgress>(`${FEATURES_PATH}/${featureId}/items`, { data: { itemIds } });
  return response.data;
}
